import { fetchApi } from '../baseApi';
import { fetchApiFile } from '../baseApi';
import { UploadFileRequest } from '../../components/shared/FileUpload/UploadFile';

export function uploadFile(data: FormData) {
    // return fetchApiFile(`api/file/upload`, data);
    return new Promise((resolve, reject) => {
        fetchApiFile(`api/file/upload`, data).then((file) => {
            resolve(file);
        }).catch(() => {
            reject(new Error('Cannot upload file!'));
        });
    });
}

export function getUploadFilesBySource(sourceId: string) {
    return new Promise((resolve, reject) => {
        fetchApi('api/files/' + sourceId, 'GET', undefined).then((files) => {
            resolve(files);
        }).catch(() => {
            reject(new Error('Cannot get files!'));
        });
    });
}

export function addNewFilesBySource(files: Array<UploadFileRequest>, sourceId: string) {
    return new Promise((resolve, reject) => {
        fetchApi('api/files/add/' + sourceId, 'POST', files).then((response) => {
            resolve(response);
        }).catch(() => {
            reject(new Error('Cannot add new files!'));
        });
    });
}

export function updateFilesBySource(files: Array<UploadFileRequest>, sourceId: string) {
    return new Promise((resolve, reject) => {
        fetchApi('api/files/update/' + sourceId, 'POST', files).then((responseFiles) => {
            resolve(responseFiles);
        }).catch(() => {
            reject(new Error('Cannot update files!'));
        });
    });
}

export function removeFile(fileId: string, sourceId: string) {
    return new Promise((resolve, reject) => {
        fetchApi('api/files/remove/' + fileId + '/' + sourceId, 'POST', undefined).then((response) => {
            resolve(response);
        }).catch(() => {
            reject(new Error('Cannot remove files!'));
        });
    });
}

export function agreementFile() {
    return new Promise((resolve, reject) => {
        fetchApi(`api/file/agreement`, 'GET').then((file) => {
            resolve(file);
        }).catch(() => {
            reject(new Error('Cannot get file!'));
        });
    });
}


// WEBPACK FOOTER //
// ./src/api/uploadFile/index.ts